export default "__VITE_ASSET__CsbMqJFG__"